/*!
 * Copyright © 2024. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ECheckboxState {
  Checked,
  Unchecked,
  Indeterminate
}
